<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">分院预约类型管理</h2>
		</div>
		<el-header>
			<span style="float: left;">&emsp;选择分院：</span>
			<el-select v-model="curbranchid" style="float: left;width: 350px;" v-on:change="BranchChanged">
				<el-option v-for="item in branchlist" :label="item.branch_name" :value="item.branch_id">
					{{ item.branch_name }}
				</el-option>
			</el-select>
		</el-header>
		<el-main>
			<li style="float: left;width: 50%;">
				<el-card>
					<div slot="header" style="text-align: left;">
						<span><b>已选预约分类</b></span>
					</div>
					<el-table tooltip-effect="dark" :data="BranchBookTypeData">

						<el-table-column prop="type_name" label="分类名称" width="100px"></el-table-column>
						<el-table-column prop="timestep" label="时间段"></el-table-column>
						<el-table-column prop="capacity" label="预约量" width="100px">
						</el-table-column>
						<el-table-column label="操作" width="280px" fixed="right">
							<template slot-scope="scope">

								<el-button @click="btnSaveBranchBookType(scope.$index, scope.row)" icon="el-icon-edit"
									type="text" size="small">保存</el-button>
								&emsp; 预约量：<el-input style="width: 80px;" type='number' v-model="scope.row.capacity">
								</el-input>
								<el-button @click="btnDelBranchBookType(scope.$index, scope.row)" icon="el-icon-delete"
									type="text" size="small">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</li>
			<li style="float: right;width: 50%;">
				<el-card>
					<div slot="header" style="text-align: left;">
						<span><b>所有预约分类</b></span>
					</div>
					<el-table tooltip-effect="dark" :data="BookTypeData">
						<el-table-column label="操作" width="80px" fixed="left">
							<template slot-scope="scope2">
								<el-button @click="btnAddBookType(scope2.$index, scope2.row)" icon="el-icon-edit"
									type="text" size="small">添加</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="type_name" label="分类名称" width="100px"></el-table-column>
						<el-table-column prop="timestep" label="时间段"></el-table-column>
						<el-table-column prop="memo" label="备注"></el-table-column>

					</el-table>
				</el-card>
			</li>
		</el-main>
	</div>
</template>

<script>
	import enums from '../../commontools/enums.js'
	import book from '../../apifunction/Book.js'
	import branch from '../../apifunction/Branch.js'
	export default {
		data() {
			return {
				BookTypeData: [],
				branchlist: [],
				BranchBookTypeData: [],
				curbranchid: ''
			}
		},
		mounted() {
			this.GetBookTypeValid();
			this.GetBranchAll();
		},
		methods: {
			GetBookTypeValid() {
				book.GetBookTypeValid()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BookTypeData = JSON.parse(ent.Data);
						} else
							this.$message.info(ent.Msg);
					})
			},
			GetBranchAll() {
				branch.GetAllBranch()
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.branchlist = JSON.parse(ent.Data);
							// if (this.branchlist.length > 0)
							// 	this.curbranchid = this.branchlist[0].branch_id;

						} else
							this.$message.info(ent.Msg);
					})
			},
			BranchChanged() {
				if (this.curbranchid == '')
					return;
				book.GetBranchBookType(this.curbranchid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchBookTypeData = JSON.parse(ent.Data);

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnAddBookType(index, row) {
				if (this.BranchBookTypeData != null) {
					var temp = this.BranchBookTypeData.find(c => c.book_type_id == row.book_type_id);
					if (temp) {
						this.$message.info('预约分类已存在！');
						return;
					}
				}
				if (this.curbranchid == '' || this.curbranchid == null) {
					this.$message.info('请选择分院！');
					return;
				}
				var info = [{
					branch_id: this.curbranchid,
					book_type_id: row.book_type_id,
					capacity: 10
				}]
				book.AddBranchBookType(info[0])
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.BranchChanged();
							// if(this.BranchBookTypeData==null)
							// this.BranchBookTypeData=info;
							// else
							// this.BranchBookTypeData.push(info[0])

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnSaveBranchBookType(index, row) {
				book.EditBranchBookType(row)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.info('保存成功！');

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnDelBranchBookType(index, row) {
				this.$confirm('确定要删除此预约分类吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					book.DelBranchBookType(row.branch_id, row.book_type_id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.BranchChanged();
							} else
								this.$message.info(ent.Msg);
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}
		}
	}
</script>

<style>
</style>
